import {Button, Form, Input, message, Modal, Space} from "antd";
import React, {useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../../../context/AuthContext";
import queryApi from "../../../../api/queryApi";

const SAVE_URL = '/admin/didox/usersave';


const DidoxUsersTab = () => {

    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const [form] = Form.useForm()

    const [open, setOpen] = useState(true);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [modalText, setModalText] = useState('Content of the modal');

    const handleOk = () => {
        setModalText('The modal will be closed after two seconds');
        setConfirmLoading(true);
        setTimeout(() => {
            //setOpen(false);
            setConfirmLoading(false);
        }, 2000);
    };

    const handleFormSubmit = () => {

        console.log('auth... ', auth)
        return false;

        form
            .validateFields()
            .then(async (values) => {
                console.log(JSON.stringify(values),'eeed')

                try {
                    const data = await queryApi.post(SAVE_URL,

                        JSON.stringify(values)
                        // )
                    ).then(response => { console.log(response, 'response')} )
                    message.success('Роль кушилди', handleCancel);
                } catch (err) {
                    message.error(err.response?.data);
                }

            })
            .catch((errorInfo) => {
                console.log('errorInfo ...', errorInfo);
            }).then(r => r);
    }

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 8 },
    };

    const tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };

    return (
        <>
            <Modal
                title="DIDOX фойдаланувчисини қўшиш"
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                footer={false}
            >
                <Space direction="horizontal" size="middle" style={{ display: "flex", justifyContent:"center", alignItems: "center", height: "100%", width: "100%", position: "relative", overflow: "hidden" }}/>

                <Form {...layout} name="addTextBook" form={form} scrollToFirstError initialValues={{}}  >
                    {/*onFinishFailed={onFinishFailed}*/}

                    <Form.Item name="login" label="Логин" rules={[{required: true, message:'Номини киритинг!'}]}>
                        <Input />
                    </Form.Item>

                    <Form.Item name="passwordNew" label="Парол" rules={[{required:true, message: 'Паролни киритинг'}]}>
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item name="confirmNew" label="Паролни тасдиклаш" rules={[{required:true, message: 'Тасдиклаш паролини киритинг'},
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('passwordNew') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Пароллар бир бирига тенг эмас'))
                            }
                        })]}>
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit" style={{marginRight:'10px'}} onClick={handleFormSubmit}>
                            Кушиш
                        </Button>

                        <Button type="ghost" htmlType="reset" danger>
                            Тозалаш
                        </Button>
                    </Form.Item>

                </Form>

            </Modal>
        </>
    )
}

export default DidoxUsersTab
